import { urlManger } from "@/url/common";
import { EntityUrl } from "@intasect/platform-core";
//@ts-ignore
export const url_subApp: EntityUrl = {
    get page() {
        return `${urlManger.getServiceUrl("user")}/system/subapp/page`;
    },
};
